var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 753.989,
    height: 800.132,
    viewBox: "0 0 753.989 800.132",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-633 -135.401)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(661.796 375.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.12,110.866l29.971,9.848V77.59H341.907Z",
    transform: "translate(-243.686 -18.331)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.855,
    cy: 29.855,
    rx: 29.855,
    ry: 29.855,
    transform: "translate(91.84 11.481)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.187,69.817l4.112,5,7.441-13.027s9.5.5,9.5-6.565,8.719-7.245,8.719-7.245,12.348-21.551-13.223-15.872c0,0-17.727-12.152-26.55-1.762,0,0-27.033,13.615-19.293,37.319l12.854,24.43,2.914-5.529S335.9,63.344,351.187,69.817Z",
    transform: "translate(-237.094 -26.143)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.119,
    height: 34.221,
    transform: "translate(87.21 501.136)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.8,514.06c2.534,0,4.792-.058,6.5-.219,6.4-.587,12.52-5.321,15.6-8.086a4.367,4.367,0,0,0,1.106-4.93h0a4.332,4.332,0,0,0-2.822-2.5l-16.932-4.838-27.414-18.5-.311.553a48.854,48.854,0,0,0-3.709,8.328,3.706,3.706,0,0,0,.265,3.087,2.948,2.948,0,0,0,1.267,1.06c-.5.518-2.05,1.578-6.842,2.338-6.992,1.106-8.466-6.139-8.524-6.439l-.046-.242-.207-.138c-3.329-2.142-5.379-3.121-6.082-2.914-.438.127-1.175.357-3.168,20.088a20.285,20.285,0,0,0-.645,9.5c1.025,4.723,21.666,3.1,25.8,2.73.115.012,15.573,1.117,26.158,1.117h0Z",
    transform: "translate(-227.976 42.007)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.119,
    height: 34.221,
    transform: "matrix(-0.771, -0.637, 0.637, -0.771, 32.903, 491.586)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.983,487.187c1.958,1.613,3.732,3.006,5.137,3.974,5.31,3.628,13.039,3.882,17.162,3.709a4.38,4.38,0,0,0,4-3.1h0a4.37,4.37,0,0,0-.576-3.732l-9.963-14.525-9.33-31.721-.587.23a49.012,49.012,0,0,0-8.167,4.054,3.714,3.714,0,0,0-1.762,2.546,2.939,2.939,0,0,0,.3,1.636c-.714.081-2.58-.092-6.761-2.557-6.093-3.594-2.615-10.125-2.453-10.4l.115-.219-.069-.23c-1.2-3.778-2.154-5.828-2.833-6.116-.426-.184-1.129-.484-15.239,13.465a20.1,20.1,0,0,0-6.554,6.911c-2.223,4.3,14.72,16.206,18.141,18.544.081.081,11.288,10.781,19.443,17.531h0Z",
    transform: "translate(-392.198 35.281)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.446,232.11H316.71l18.383,273.479h27.575l36.766-273.48h0Z",
    transform: "translate(-248.229 5.13)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.007,247.176l16.851-15.066-8.42,150.406L340.207,472.14l-23.5-19.408,54.908-71.241Z",
    transform: "translate(-291.642 5.13)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.129,93.315,349.273,86.68,336.58,108.864a150.668,150.668,0,0,0-18.752,93.114l6.416,52.213H406.98L390.129,93.315h0Z",
    transform: "translate(-255.763 -16.951)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.064,246.982c6.865,5.195,9.618,13.039,6.151,17.531s-11.852,3.928-18.717-1.267a20.682,20.682,0,0,1-6.473-7.844l-28.8-22.369L263.54,219.35l27.195,23.509a21.182,21.182,0,0,1,9.353,4.124h-.023Z",
    transform: "translate(-82.226 3.192)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.463,251.421,348.635,195.8,315.889,132.99a24.943,24.943,0,1,0-42.606,25.755l47.1,67.728.069.1,72.059,42.434,10.942-17.6h.012Z",
    transform: "translate(-197.085 -11.958)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(959.417 135.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.52,268.471h-4.38V148.58a69.39,69.39,0,0,0-69.39-69.39h-254a69.39,69.39,0,0,0-69.39,69.39V806.3a69.39,69.39,0,0,0,69.39,69.39h254a69.39,69.39,0,0,0,69.39-69.39v-452.5h4.38Z",
    transform: "translate(-266.362 -79.19)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.9,95.686H557.751a24.619,24.619,0,0,1-22.8,33.918H389.428a24.619,24.619,0,0,1-22.8-33.918H335.669a51.82,51.82,0,0,0-51.82,51.82V804.264a51.819,51.819,0,0,0,51.818,51.819H590.893a51.82,51.82,0,0,0,51.82-51.82V147.506A51.819,51.819,0,0,0,590.9,95.686Z",
    transform: "translate(-264.702 -77.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M996.259,449.177H684.893a10.476,10.476,0,0,1-10.464-10.464v-45.6a10.476,10.476,0,0,1,10.464-10.464H996.259a10.476,10.476,0,0,1,10.464,10.464v45.6a10.476,10.476,0,0,1-10.464,10.465Z",
    transform: "translate(217.75 13.047)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.076,441.187H691.023a10.476,10.476,0,0,1-10.464-10.464v-31.48a10.476,10.476,0,0,1,10.464-10.464H988.27a10.477,10.477,0,0,1,10.464,10.464v8.285a33.7,33.7,0,0,1-33.659,33.659Z",
    transform: "translate(218.68 13.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.352,409.422H737.207a2.7,2.7,0,0,1,0-5.4H862.352a2.7,2.7,0,1,1,0,5.4Z",
    transform: "translate(226.872 16.293)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.7,419h-188.5a2.7,2.7,0,1,1,0-5.4H925.7a2.7,2.7,0,1,1,0,5.4Z",
    transform: "translate(226.872 17.748)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.259,533.177H684.893a10.476,10.476,0,0,1-10.464-10.464v-45.6a10.477,10.477,0,0,1,10.464-10.464H996.259a10.476,10.476,0,0,1,10.464,10.464v45.6a10.476,10.476,0,0,1-10.464,10.464Z",
    transform: "translate(217.75 25.801)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.076,525.187H691.023a10.476,10.476,0,0,1-10.464-10.464v-31.48a10.476,10.476,0,0,1,10.464-10.464H988.27a10.477,10.477,0,0,1,10.464,10.464v8.285a33.7,33.7,0,0,1-33.659,33.659Z",
    transform: "translate(218.68 26.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.352,493.422H737.207a2.7,2.7,0,0,1,0-5.4H862.352a2.7,2.7,0,1,1,0,5.4Z",
    transform: "translate(226.872 29.047)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.7,503h-188.5a2.7,2.7,0,1,1,0-5.4H925.7a2.7,2.7,0,1,1,0,5.4Z",
    transform: "translate(226.872 30.502)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.259,617.177H684.893a10.476,10.476,0,0,1-10.464-10.464v-45.6a10.476,10.476,0,0,1,10.464-10.464H996.259a10.477,10.477,0,0,1,10.464,10.464v45.6a10.476,10.476,0,0,1-10.464,10.464Z",
    transform: "translate(217.75 38.555)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.076,609.187H691.023a10.476,10.476,0,0,1-10.464-10.464v-31.48a10.477,10.477,0,0,1,10.464-10.464H988.27a10.477,10.477,0,0,1,10.464,10.464v8.285A33.7,33.7,0,0,1,965.076,609.187Z",
    transform: "translate(218.68 39.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.352,577.422H737.207a2.7,2.7,0,1,1,0-5.4H862.352a2.7,2.7,0,1,1,0,5.4Z",
    transform: "translate(226.872 41.801)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.7,587h-188.5a2.7,2.7,0,1,1,0-5.4H925.7a2.7,2.7,0,1,1,0,5.4Z",
    transform: "translate(226.872 43.256)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1112.037 229.628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.317,81.006H4.607a4.607,4.607,0,0,1-2.27-8.616c3.607-2.042,5.555-5.76,6.317-12.053l1.713-15.462a40.528,40.528,0,0,1,20.9-33.451c1.282-7.567,7.268-15.2,14.736-15.2,7.94,0,13.372,8.184,14.625,15.183A40.7,40.7,0,0,1,81.58,45.167l1.7,15.215c.757,6.25,2.7,9.967,6.307,12.008a4.607,4.607,0,0,1-2.27,8.616ZM14.934,71.791H76.99a31.973,31.973,0,0,1-2.863-10.347L72.4,45.891a31.658,31.658,0,0,0-18.068-27.36,4.607,4.607,0,0,1-2.638-4.165c0-3.836-3.242-8.923-5.686-8.923-2.466,0-5.731,5.017-5.776,8.844a4.615,4.615,0,0,1-2.725,4.285A31.516,31.516,0,0,0,19.548,45.6L17.807,61.4A32.117,32.117,0,0,1,14.934,71.791Z",
    transform: "translate(0 3.771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.115,42.892A20.138,20.138,0,0,1,5,22.777V17.607a4.607,4.607,0,1,1,9.215,0v5.169a10.9,10.9,0,1,0,21.8,0V17.607a4.607,4.607,0,0,1,9.215,0v5.169A20.138,20.138,0,0,1,25.115,42.892Z",
    transform: "translate(20.847 62.562)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M650,259.482a17.1,17.1,0,0,0,2.211,7.289,24.671,24.671,0,0,0,12.262,10.17c6.2,2.538,13.117,2.616,19.7,2.05,6.114-.526,12.165-1.744,18.3-2a127.518,127.518,0,0,1,14.229.339c9.182.652,18.326,1.861,27.412,3.327q3.691.588,7.366,1.264a3.646,3.646,0,0,1,.684.127c.044.018.116,0,.157.03.074.047-.3-.118-.073.069a6.788,6.788,0,0,1,.839,1.08l3.355,4.318a20.406,20.406,0,0,0,3.1,3.719,5.611,5.611,0,0,0,6.211.433,6.207,6.207,0,0,0,2.31-2.624,22.64,22.64,0,0,1,2.747-3.965c3.992-4.657,9.54-7.521,14.18-11.44a25.258,25.258,0,0,0,5.671-6.483,18.332,18.332,0,0,0,2.343-7.28,24.35,24.35,0,0,0-3.73-14.949,29.862,29.862,0,0,0-12.122-11.1,52.331,52.331,0,0,0-18.06-4.949,163.637,163.637,0,0,0-19.95-.661q-11.188.125-22.335.984-11.163.864-22.237,2.456a194.042,194.042,0,0,0-21.19,3.882c-6.126,1.592-12.235,4.081-16.81,8.59C652.5,248.178,649.67,253.664,650,259.482Z",
    transform: "translate(464.641 569.208)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.491,244.693c-6.613,1.22-13.535,2.714-19.084,6.332-5.488,3.579-8.825,9.205-8.5,14.334.474,7.491,8.439,13.094,15.693,14.561,6.948,1.405,14.186.454,21.848-.555,1.7-.223,3.449-.454,5.184-.654,18.862-2.18,54.278,4.535,55.777,4.822l1.557.3,8.244,10.609a29.9,29.9,0,0,1,8.6-10.663c1.586-1.267,3.241-2.444,4.841-3.583,4.083-2.9,7.939-5.646,10.068-9.414,4.635-8.205-.842-19.647-8.657-24.783-8.8-5.787-20.407-6.694-31.634-6.814q-1.754-.019-3.51-.019a333.633,333.633,0,0,0-60.383,5.517Z",
    transform: "translate(458.516 563.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.786,270.216a1.732,1.732,0,0,1,1.73-1.734H793.13a1.732,1.732,0,1,1,0,3.464H713.516A1.732,1.732,0,0,1,711.786,270.216Z",
    transform: "translate(429.944 546.61)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.786,294.453a1.732,1.732,0,0,1,1.73-1.734h79.617a1.732,1.732,0,0,1,0,3.464H713.516A1.732,1.732,0,0,1,711.786,294.453Z",
    transform: "translate(429.944 533.006)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.12,318.69a1.732,1.732,0,0,1,1.73-1.734h9.278a1.732,1.732,0,0,1,0,3.464h-9.278A1.732,1.732,0,0,1,872.12,318.69Z",
    transform: "translate(339.945 519.401)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.081,258.042c-.043,0-.087,0-.131,0a3.131,3.131,0,0,1-2.558-1.94,45.565,45.565,0,0,0-7.566-10.93c-1.776-1.893-3.631-3.652-5.426-5.355-4.629-4.389-8.989-8.523-11.409-14.236-5.276-12.456.937-29.8,9.814-37.585,9.957-8.726,23.053-10.095,35.722-10.274q1.975-.028,3.952-.028h0a285.784,285.784,0,0,1,68.057,8.3c7.465,1.837,15.279,4.087,21.559,9.547,6.242,5.428,10.036,13.976,9.666,21.777-.541,11.389-9.594,19.9-17.838,22.123-7.858,2.119-16.021.687-24.662-.83-1.908-.334-3.88-.681-5.831-.981-21.2-3.268-61.026,6.8-62.711,7.235l-1.672.427-6.486,11.13a2.925,2.925,0,0,1-2.481,1.625Z",
    transform: "translate(543.744 577.478)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.283,215.085H583.677a1.95,1.95,0,0,1,0-3.9h89.606a1.95,1.95,0,0,1,0,3.9Z",
    transform: "translate(502.948 568.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.281,242.364H583.675a1.95,1.95,0,0,1,0-3.9h89.61a1.95,1.95,0,1,1,0,3.9Z",
    transform: "translate(502.951 553.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.12,269.643H583.677a1.95,1.95,0,0,1,0-3.9H594.12a1.95,1.95,0,1,1,0,3.9Z",
    transform: "translate(502.948 538.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.18,489a1.677,1.677,0,0,0,1.506,1.814H767.663a1.845,1.845,0,0,0,0-3.628H16.686A1.677,1.677,0,0,0,15.18,489Z",
    transform: "translate(617.82 444.714)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.00a6ce0af08f56de0b8ae162f900ff4b.svg";
export { ForwardRef as ReactComponent };